import { Box, ModalDialog, Spacer, Text } from '@jfs/ui-new'
import { useIsLargeScreen } from '@jfs/ui-new/src/utils/utils'
import { getLoadingState } from '@jfs/utils'
import { useNavigation, useRoute } from '@react-navigation/native'
import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import ActionsMenu from '../../comps/ActionMenu/ActionsMenu'
import EmptyView from '../../comps/EmptyView'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { NewTable } from '../../comps/NewTable'
import { StatusReceiver } from '../../comps/StatusReceiver/StatusReceiver'
import { paymentLinksTitleData } from '../../data/static/data'
import { staticStrings, transactionScreenStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { getCustomColumnWidth, getErrorMessage, getWidth, tableConfig, useWindowDimensions } from '../../util/util'
import { PaymentLinkDetails } from '../PaymentLinkDetails'
import { TransactionsType } from '../TransactionNew/types'
import styles from './styles'

const PaymentLinks: FC = () => {
  const {
    mid,
    fetchPaymentLinks,
    getPaymentLinksData,
    fetchPayLinksOnDateChange,
    pageNumber,
    resetPagination,
    paymentDetails,
    updateNewLink,
    isNewLinkCreated,
    selectedDateInfo,
    updateSelectedDate,
    canCreatePaymentLink,
  } = useStores((store) => ({
    mid: store.user.selectedMid,
    fetchPaymentLinks: store.links.fetchPaymentLinks,
    getPaymentLinksData: store.links.getPaymentLinksData,
    fetchPayLinksOnDateChange: store.fetchPayLinksOnDateChange,
    pageNumber: store.links.pagination.number,
    resetPagination: store.links.resetPagination,
    paymentDetails: store.links.getPaymentDetails,
    updateNewLink: store.links.updateNewLinkCreatedInStore,
    isNewLinkCreated: store.links.isNewLinkCreated,
    selectedDateInfo: store.links.selectedDateInfo,
    updateSelectedDate: store.links.updateSelectedDateInfo,
    canCreatePaymentLink: store.userManagement.canCreatePaymentLink(),
  }))
  const viewPortWidth = useWindowDimensions()

  const isLargeScreen = useIsLargeScreen()
  const [fetchPayLinks, fetchPayLinksHandler] = useLazyApiData(fetchPaymentLinks)
  const apis = [fetchPayLinksHandler]
  const loadingState = getLoadingState(apis)
  const errorState = getErrorMessage(apis)

  const [filterVisible, setFilterVisible] = useState(false)
  const [fieldSettingVisible, setFieldSettingVisible] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [selectedId, setSelectedId] = useState('')
  const [isInfoToastVisible, setInfoToastVisible] = useState(isNewLinkCreated ?? false)
  const [toastType, updateToastType] = useState('')

  const navigation = useNavigation()

  const detailsData = paymentDetails(selectedId, { duplicate: false })
  const isResendToast = toastType === 'resend'
  const isCancelToast = toastType === 'cancel'

  useEffect(() => {
    if (mid !== '') {
      fetchPayLinksOnDateChange(fetchPayLinks)
    }
  }, [mid, fetchPayLinksOnDateChange, fetchPayLinks])

  const path = useRoute().name
  const themes = styles(0)

  const listData = getPaymentLinksData(!isLargeScreen)
  const scrollViewStyle = () => {
    if (listData?.length === 0) {
      return themes.emptyContainer
    }
    return themes.tableContainer(loadingState)
  }
  const scrollStyle = scrollViewStyle()

  const onPress = (_item: any) => {
    setShowDetails(true)
    setSelectedId(_item?.jioLinkId)
  }

  // const onItemAction = (_actionType: ActionType, _id: string) => {}
  const handleRetry = (): void => {
    fetchPayLinks(mid, false)
  }

  const getEmptyMessage = (): string => {
    return listData?.length === 0 ? transactionScreenStrings.noRecords : transactionScreenStrings.empty
  }
  const handleCreateLink = () => {
    showStatusComp()
    navigation?.navigate(Routes.CREATE_PAYMENT_LINK)
  }

  const fetchDetailOfPath = () => {
    if (!filterVisible) {
      fetchPayLinksOnDateChange(fetchPayLinks)
    }
  }

  const fetchDetailsOnFiltersClick = () => {
    resetPagination()
    fetchPayLinksOnDateChange(fetchPayLinks)
  }

  const showStatusComp = () => {
    updateToastType('cancel')
    setInfoToastVisible(true)
  }

  const hideStatusComp = () => {
    updateNewLink(false)
    setInfoToastVisible(false)
  }

  const refreshListingPage = () => {
    resetPagination()
    fetchPayLinksOnDateChange(fetchPayLinks)
  }

  const showSuccessToastOfResendLink = () => {
    setInfoToastVisible(true)
    updateToastType('resend')
  }

  const renderTransactionDetails = (): React.ReactElement => {
    return (
      <PaymentLinkDetails
        onDismiss={onDismiss}
        id={selectedId}
        showStatusComponent={(val: boolean | undefined) => showStatusComp(val)}
        refreshListingPage={refreshListingPage}
        showSuccessToastOfResendLink={showSuccessToastOfResendLink}
      />
    )
  }

  const onDismiss = () => {
    setShowDetails(false)
  }

  const mobile = detailsData?.pushSmsTo ?? ''
  const email = detailsData?.pushEmailTo ?? ''

  const returnHelperText = () => {
    // Todo
    if (mobile !== '' && email !== '') {
      return 'Sending via SMS & Email'
    } else if (mobile === '' && email !== '') {
      return 'Sending via Email'
    } else if (mobile !== '' && email === '') {
      return 'Sending via SMS'
    } else if (!isResendToast && !isCancelToast) {
      return 'Sending via SMS & Email'
    }
  }

  const renderMaintText = () => {
    if (isCancelToast) {
      return 'Payment Link Cancelled'
    } else if (isResendToast) {
      return 'Payment link resent successfully'
    } else {
      return 'Payment Link created successfully'
    }
  }

  return (
    <Box flex={1} overflowY={fieldSettingVisible || filterVisible ? 'auto' : 'hidden'}>
      <Box {...themes.maincontainer}>
        <ModBox
          show={isNewLinkCreated || isInfoToastVisible}
          w="100%"
          alignSelf="center"
          position="absolute"
          pointerEvents="box-none"
          top={10}
          zIndex={99999}>
          <StatusReceiver
            hide={!(isNewLinkCreated || isInfoToastVisible) || !isInfoToastVisible}
            type={'successfullWithCloseBtn'}
            mainText={renderMaintText()}
            helperText={isCancelToast ? '' : returnHelperText()}
            onRightButtonPress={hideStatusComp}
            autoDismiss={true}
            testID={'successfullyPaymentLinkCreated'}
          />
        </ModBox>
        <ModalDialog children={renderTransactionDetails()} show={showDetails} type={'Right'} onDismiss={onDismiss} />
        <Box {...themes[path as TransactionsType].container}>
          <Box {...themes.stickyHeader}>
            <Box {...themes.titlecontainer}>
              <Text type={'title'} color={'BLACK_21'}>
                {staticStrings.paymentLinks}
              </Text>
              <ModBox
                {...themes.createLinkBtn}
                show={canCreatePaymentLink}
                testID="create-link"
                onPress={handleCreateLink}>
                <Text fontFamily={'jiotype-medium'} fontSize={12} color={'WHITE'}>
                  {staticStrings.createPaymentLink}
                </Text>
              </ModBox>
            </Box>

            <ActionsMenu
              path={'links'} //Should be links as its used to map the pagination in ActionsMenu
              fieldSettingVisible={false}
              setFieldSettingVisible={setFieldSettingVisible}
              filterVisible={filterVisible}
              setFilterVisible={setFilterVisible}
              hideFieldSettings={true}
              fetchDetailOfPath={fetchDetailOfPath}
              fetchDetailsOnFiltersClick={fetchDetailsOnFiltersClick}
              selectedDateInfo={selectedDateInfo}
              updateSelectedDate={updateSelectedDate}
              maxRange={31}
            />
          </Box>
          <Spacer
            direction={'vertical'}
            size={listData.length > 0 && fetchPayLinksHandler.state !== 'pending' ? 0 : 16}
          />
          <EmptyView
            isLoading={loadingState}
            onRetry={() => {
              if (handleRetry) {
                handleRetry()
              }
            }}
            error={errorState}
            loadingMessage=""
            emptyMessage={getEmptyMessage()}
            loaderColor={'BLUE'}
            hide={listData.length > 0 && fetchPayLinksHandler.state !== 'pending'}
          />
          <Box {...scrollStyle} nativeID={'scroll-horizontal-Table'} f={1}>
            <NewTable
              data={listData}
              rowHeight={48}
              headerHeight={64}
              customWidthFunc={getCustomColumnWidth}
              tableWidth={getWidth(viewPortWidth > 1200 ? viewPortWidth - 280 : viewPortWidth, paymentLinksTitleData)}
              headerRowKeys={paymentLinksTitleData}
              transactionType={tableConfig(path).status}
              onRowClick={onPress}
              hide={
                filterVisible ||
                fieldSettingVisible ||
                loadingState ||
                !(!loadingState && !errorState && !getEmptyMessage())
              }
              sortBy="invoice"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PaymentLinks
